module.exports = __webpack_public_path__ + "3afbf8e06711c5dbe424cb24ba070cd7.svg";